import { capitalize } from "../../../shared/utils";
import AbstractField from "./AbstractField";

export default class SimpleField extends AbstractField {
    type = 'p';
    styles = [];
    staticValue = null;

    setType(type) {
        if (this.initialized) {
            throw new Error('Cannot change type of initialized field');
        }
        this.type = type;
        return this;
    }

    populate(element) {
        if (!this.staticValue) {
            this.populateFunction(element, this.field);
        }
    }

    setDrawMode(type) {
        if (this.showInDrawMode && this.supportedTypes.includes(type)) {
            if (!this.staticValue) {
                this.field.html(capitalize(type));
            }
            this.show();
        } else {
            this.hide();
        }
    }

    style(...values) {
        this.initialized
            ? this.field.style(...values)
            : this.styles.push(values);
        return this;
    }

    setStaticValue(value) {
        this.staticValue = value;
        return this;
    }

    make() {
        this.field = this.p.createElement(this.type, this.staticValue);
        this.parentElement ? this.field.parent(this.parentElement) : null;
        this.applyClasses();
        this.applyStyles();
        this.initialized = true;
        return this;
    }

    reset() {
        this.field.html('');
    }

    value(value) {
        this.field.html(value);
    }
}
